import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root{
    /* Modern 2025 Palette */
    --primary: #6366f1;
    --secondary: #8b5cf6;
    --accent: #06b6d4;
    --success: #10b981;
    --warning: #f59e0b;
    --dark: #0f172a;
    --dark-secondary: #1e293b;
    --light: #f8fafc;
    --light-secondary: #e2e8f0;
    --text-light: #cbd5e1;
    --gradient-primary: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    --gradient-accent: linear-gradient(135deg, #06b6d4 0%, #10b981 100%);
    --gradient-warm: linear-gradient(135deg, #f59e0b 0%, #ef4444 100%);
    
    /* Legacy colors for backwards compatibility */
    --pink: #E31F71;
    --black: #212121;
    --green: #10b981;
    --blue: #6366f1;
    scroll-padding-top: 10rem;

    &.light{

      body{
        transition: 0.5s;
        background-color: #f5f5f5;
        color: var(--black);
      }

      .logo{
        color: var(--black);
      }

      header.header-fixed{
        transition: 0.5s;
        background-color: #f5f5f550;
        a{
          transition: 0.5s;
          color: black;
        }
        .menu,.menu:before, .menu:after{
          background-color: var(--black); 
        }
        .menu.active{
          background-color: rgba(555,555,555,0);
        }
      }

      footer.footer{
        transition: 0.5s;
        background-color: rgba(0,0,0,0.1);
        color: var(--black);
      }

      form{
        input,textarea{
          transition: 0.5s;
          border: solid 1px var(--black);
          color: var(--black);
          &::placeholder{
            transition: 0.5s;
            color: var(--black);
          }
        }
      }

    }
  }

  ul, li {
    text-decoration: none;
    list-style: none;
    margin: 0;
    padding:0;
  }

  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html{
    font-size: 62.5%;
  }

  body{
    font-size: 1.6rem;
    -webkit-font-smoothing: antialiased;
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
    background-attachment: fixed;
    color: #FFFF;
  }

  body, input, textarea, button{
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 400;
  }

  a{
    text-decoration: none;
  }

  button, .button{
    border: none;
    cursor: pointer;
    background: var(--gradient-primary);
    color: #FFFF;
    border-radius: 1.2rem;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
    
    &:hover{
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
    }
    
    &:active{
      transform: translateY(0);
    }
  }

  button:disabled, .button:disabled{
    filter: brightness(0.8);
    cursor: not-allowed;
  }


  .logo{
    font-size: clamp(2rem, 3vw, 3rem);
    font-weight: 700;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  h1 {
    font-size: clamp(3.5rem, 8vw, 7rem);
    font-weight: 800;
    line-height: 1.1;
  }
  
  h2 {
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 700;
  }
  
  h3 {
    font-size: clamp(1.8rem, 3vw, 2.5rem);
    font-weight: 600;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* Light theme — extends the rules above for components not covered there */
  :root.light {
    body {
      background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f8fafc 100%);
      color: var(--black);
    }

    section h2 {
      filter: brightness(0.85);
    }

    .project {
      background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%) !important;
      border-color: rgba(99, 102, 241, 0.25) !important;
      color: var(--black) !important;

      h3 { color: var(--black) !important; text-shadow: none !important; }
      p  { color: #334155 !important; }

      .tech-list li {
        background: rgba(99, 102, 241, 0.08) !important;
        color: var(--primary) !important;
      }

      .project-links a {
        background: rgba(99, 102, 241, 0.06) !important;
      }
    }

    .achievement-badges .badge {
      color: #1e293b !important;
      background: linear-gradient(135deg,
        rgba(99, 102, 241, 0.10) 0%,
        rgba(139, 92, 246, 0.08) 100%) !important;
    }

    .small-resume {
      color: #334155 !important;
    }
  }
`